import React, { useEffect, useState } from 'react';
import { Typography, Button, Input, Card, Tooltip, Avatar, Empty } from 'antd';
import styles from './MessageList.module.scss';
import * as _ from 'lodash';
import { AiOutlineDoubleLeft, AiOutlineDoubleRight, AiOutlineLeft, AiOutlineRight } from "react-icons/ai";
import Pagination from "react-js-pagination";
import moment from 'moment';
import { useSelector, useDispatch } from 'react-redux';
import './MessageListStyle.scss';
import { CommentOutlined, PlusOutlined } from '@ant-design/icons';
import { ADMIN, CUSTOMER, TEAM_LEAD } from '../../../api/Constants';
import ConfirmationDialog from "../../ConfirmationDialog";
import { seenLatestMessage } from '../../../services/inboxService';
import { convertServerToLocalTime, isMobile } from '../../../api/Util';
import CustomDropdown from '../../common/CustomDropdown/DropDown';
import { Inbox_LOADING, INBOX_SET_STATE, SET_ADD_TITLE, SET_CHAT_TITLE, SET_INBOX_CURRENT_SELECTED_MESSAGE, SET_INBOX_HAS_MORE, SET_INBOX_MESSAGE, SET_PAGE } from '../../../actions/types';

const MessageList = ({
	status,
	filterMessages,
	setFilterMessages,
	setIsModalOpen,
	getChatById,
	handleInboxMessage,
	cardClick,
}) => {
	const [confirmationOpen, setConfirmationOpen] = useState({ open: false, id: "" });
	const props = useSelector((state) => state);
	const loggedInUser = props.auth.loggedInUser;
	const websiteUsers = useSelector(state => state.allWebsiteUsers.website_users);
	const { page, rowsCount, loading, updatedCount, inboxMessage, currentSelectedMessage } = useSelector((state) => state.inboxSeenMessages);
	const dispatch = useDispatch();
	const limit = 10;
	const handleCardClick = (card, seenArray, i) => {
		dispatch({type: SET_INBOX_HAS_MORE, payload: true});
		dispatch({type: SET_INBOX_CURRENT_SELECTED_MESSAGE, payload: card.id});
		dispatch({ type: SET_CHAT_TITLE, payload: card.title});
		dispatch({type: INBOX_SET_STATE, payload: {comments: {}, commentsArray: []}})
		getChatById('noCall', card.id, 0);
		seenArray.push(loggedInUser.client_id);
		if (card.status === "ACTIVE" && !(seenArray.includes(loggedInUser.client_id.toString()))) {
			seenLatestMessage(card.id, card.seen);
			document.getElementById(i + "_card_style").style.border = 'none';
			document.getElementById(i + "_comment_outlined").style.color = '#616161';
			document.getElementById(i + "_total_count").style.color = '#616161';
		}
		if (isMobile) {
			cardClick();
		}
	}

	const setViewAs = (v) => {
		dispatch({type: SET_INBOX_MESSAGE, payload: []});
		dispatch({ type: SET_PAGE, payload: 1 });
		dispatch({type: Inbox_LOADING, payload: true});
		dispatch({ type: SET_CHAT_TITLE, payload: "" });
		dispatch({type: INBOX_SET_STATE, payload: {comments: {}, commentsArray: []}})
		setFilterMessages({ view_as: v });
	}

	useEffect(() => {
		const newState = inboxMessage.map(obj => {
			if (obj.id === currentSelectedMessage) {
				return { ...obj, total_count: updatedCount };
			}
			return obj;
		});
		dispatch({type:SET_INBOX_MESSAGE, payload: newState});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [updatedCount])




	return (
		<div className='messageListContainer'>
			<ConfirmationDialog
				onNegative={() => setConfirmationOpen(false)}
				onPositive={() => handleInboxMessage(confirmationOpen.id, confirmationOpen.status)}
				confirmationHeader="Caution"
				confirmationDialogId={confirmationOpen.id}
				confirmation={confirmationOpen.open}
				confirmationText={`Are you sure you want to ${confirmationOpen.status} message?`}
			/>
				<Typography.Text strong className={styles.mobileMode}>
					Total Messages ({rowsCount})
				</Typography.Text>
			<div className={`${styles.msgCountAndDivWrapper} msgCountAndDivWrapper`}>
				<div className={styles.searchFieldAndCreateBtnWrapper}>
					{
						(loggedInUser.client_type !== CUSTOMER) &&
						<CustomDropdown
							options={_.concat(websiteUsers || [])
								.filter(user => user.client_type === CUSTOMER)
								.map(user => ({ value: user.client_id, label: user.fullname, className: user?.is_deleted ? 'deleted-user' : ''}))
							}
							placeholder="View As"
							className={styles.viewAsStyle}
							dropdownValue={filterMessages.view_as}
							handleOnchange={setViewAs}
						/>
					}
					<Input.Search
						placeholder="Search Message"
						allowClear
						className={styles.searchInput}
						onSearch={(value) => setFilterMessages({ ...filterMessages, message_title: value })}
					/>
					{ 
						(status === "ACTIVE") && 
						 isMobile ? <Button type="primary" icon={<PlusOutlined />} className={`${styles.newMessageBtn} new-message-btn`} onClick={() => setIsModalOpen(true)}></Button> :
							 <Button type="primary" className={`${styles.newMessageBtn} standard-btn`} onClick={() => setIsModalOpen(true)}>Add New Message</Button>
						
					}
				</div>
				<Typography.Text strong className={styles.deskMode}>
					Total Messages ({rowsCount})
				</Typography.Text>
			</div>
			<div className={styles.cardWrapper}>
				{
					!inboxMessage?.length > 0 && <Card className={styles.cards} loading={loading}>
						<Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={"No Message Found"} />
					</Card>
				}
				{inboxMessage && inboxMessage?.map((card, i) => {
					let seenArray = card.seen.split(',');
					return <Card
						id={i + "_card_style"}
						key={card.id}
						style={{ border: card.status === "ACTIVE" && !(seenArray.includes(loggedInUser.client_id.toString())) ? '1px solid green' : 'none' }}
						title={
							<div className={styles.titleWrapper}>
								<Typography.Text>{card.title}</Typography.Text>
								{
									loggedInUser.client_type !== CUSTOMER &&
									<button
										className={card.status === "ACTIVE" ? `standard-btn standard-btn-normal-padding ${styles.resolveBtn}` : `standard-btn standard-btn-normal-padding  ${styles.disableResolveBtn}`}
										disabled={card.status === "ACTIVE" ? false : true}
										onClick={(e) => { e.stopPropagation(); setConfirmationOpen({ open: true, id: card.id, status: 'Resolve' }) }}
									>{card.status === "ACTIVE" ? isMobile ? "Resolve" : "Click to Resolve" : "Resolved"}
									</button>
								}
								{
									loggedInUser.client_type === CUSTOMER && card.status === "RESOLVED" &&
									<button
										className={styles.resolveBtn}
										onClick={(e) => { e.stopPropagation(); dispatch({ type: SET_ADD_TITLE, payload: card.title }); setIsModalOpen({ open: true, id: card.id, status: 'Re-open' }) }}
									>{isMobile ? "Re-open" : "Click to Re-open"}
									</button>
								}
							</div>
						}
						bordered={false}
						className={`${styles.cards} cardsStyle`}
						onClick={() => handleCardClick(card, seenArray, i)}
					>
						<div className={styles.avatarAndMessageWrapper}>
							<Tooltip title={
								card?.client_firstname || card?.client_lastname ? `${card?.client_firstname || ''} ${card?.client_lastname || ''}` : 'N/A'
							} placement="top">
								<Avatar className={styles.messageListAvatar}>
									{card?.client_firstname || card?.client_lastname ?
										`${card?.client_firstname.toUpperCase().charAt(0)}${card?.client_lastname.toUpperCase().charAt(0)}` : 'N/A'}
								</Avatar>
							</Tooltip>
							<div style={{ width: '100%' }}>
								<div className={styles.msgAndCountWrapper}>
									<Typography.Text>{card.latest_message}</Typography.Text>
									<div className={styles.iconAndTextContainer}>
										<CommentOutlined id={i + "_comment_outlined"} className={card.status === "ACTIVE" && !(seenArray.includes(loggedInUser.client_id.toString())) ? styles.greenFontColor : styles.greyFontColor} />
										<Typography.Text id={i + "_total_count"} className={card.status === "ACTIVE" && !(seenArray.includes(loggedInUser.client_id.toString())) ? styles.greenFontColor : styles.greyFontColor}>{card.total_count}</Typography.Text>
									</div>
								</div>
								<span className={styles.dateStyle}>{moment(convertServerToLocalTime(card.created_at)).format('ll')}</span>
							</div>
						</div>
					</Card>
				})}
			</div>
			{
				rowsCount > limit &&
				<div className={`center-align ${styles.paginationDiv}`}>
					<Pagination
						className={styles.paginationStyle}
						activePage={page}
						itemsCountPerPage={10}
						totalItemsCount={rowsCount}
						pageRangeDisplayed={10}
						onChange={i => dispatch({ type: SET_PAGE, payload: (i) })}
						prevPageText={<AiOutlineLeft />}
						nextPageText={<AiOutlineRight />}
						firstPageText={<AiOutlineDoubleLeft />}
						lastPageText={<AiOutlineDoubleRight />}
					/>
				</div>
			}
		</div>
	)
}

export default MessageList;
